<template>
  
    <el-container>
     
      <el-main>
       <h1>表格模式</h1>
       <p>在 markdown 中添加 yaml</p>
       <pre>
        <code>
---

mindmap-plugin: basic
display-mode: table

---
        </code>
       </pre>
       <p>在更多菜单中点击 <i>打开为思维导图</i></p>
       <div>
          <img src="../assets/markmind/table.gif" alt="" width="800">
       </div>

       <h3>获取表格的 markdown 文本</h3>

       <p>在更多菜单中点击菜单 <i>获取表格的markdown文本</i>  </p>

       <br>
        <div>
          <img src="../assets/markmind/tablemd.gif" alt="" width="800">
       </div>

      </el-main>
    </el-container>
 
</template>

<script>
export default {
  name: 'tableePage',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
